import { Box, Button, Dialog, Stack } from "@mui/material";
import React from "react";
import CloseIcon from "../Icons/circleClose.svg";
import { TypographyDefault } from "../Theme";
import axiosInstance from "../AxiosInstance";
import { showToast } from "../CommonComponents/Toaster";

const ConfirmRelocateDialogComponent = ({
  open,
  onClose,
  selectedCompanyDetails,
  relocatingCompanyId,
  reloacatingCompanyName,
  reloacatingCompanyProjects,
}) => {
  const handleRelocateProjects = () => {
    axiosInstance
      .post(
        `${process.env.REACT_APP_API_URL}company/relocate-projects/${relocatingCompanyId}`,
        { company_id: selectedCompanyDetails?.id }
      )
      .then((res) => {
        if (res.data?.success) {
          showToast(res.data?.message, "success");
          onClose();
        }
      })
      .catch((err) => {
        console.log(err);
        onClose();
        showToast("Internal server error", "error");
      });
  };
  return (
    <Dialog
      PaperProps={{
        sx: {
          width: "580px",
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar for WebKit browsers
          },
          "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
          "scrollbar-width": "none", // Hide scrollbar for Firefox
          borderRadius: " 8px",
        }, // Set width and prevent horizontal overflow
      }}
      open={open}
      onClose={onClose}
    >
      <Stack width="100%">
        <Box
          pt="16px"
          px="16px"
          pb="16px"
          display="flex"
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ borderBottom: "0.5px solid #E5E5E5" }}
        >
          <TypographyDefault
            sx={{ fontSize: "18px !important", fontWeight: "600 !important" }}
          >
            Relocate projects
          </TypographyDefault>
          <img
            src={CloseIcon}
            alt="Custom Icon"
            style={{
              cursor: "pointer",
            }}
            onClick={onClose}
          />
        </Box>

        <Stack py="16px" px="24px">
          <TypographyDefault
            sx={{
              fontSize: "16px",
              color: "#1F2A37 !important",
              fontWeight: 400,
            }}
          >
            Are you sure that you would like to relocate{" "}
            {reloacatingCompanyProjects} projects from company list '
            {reloacatingCompanyName}' to '{selectedCompanyDetails?.name}'
          </TypographyDefault>
        </Stack>

        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          pb="24px"
          pt="16px"
          px="24px"
          sx={{ borderTop: "0.5px solid #E5E5E5" }}
        >
          <Button variant="white" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleRelocateProjects} variant="contained">
            Confirm
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default ConfirmRelocateDialogComponent;
